
import { UserRole } from "@/lib/types";
import { Badge } from "@/components/ui/badge";
import { ShieldAlert, Shield, UserCheck } from "lucide-react";

interface UserRoleBadgeProps {
  role: UserRole;
  onRemove?: (role: UserRole) => void;
}

export function UserRoleBadge({ role, onRemove }: UserRoleBadgeProps) {
  const getRoleIcon = (role: UserRole) => {
    switch (role) {
      case "ADMIN":
        return <ShieldAlert className="h-4 w-4 mr-1" />;
      case "DEVELOPER":
        return <Shield className="h-4 w-4 mr-1" />;
      case "TESTER":
        return <UserCheck className="h-4 w-4 mr-1" />;
      default:
        return null;
    }
  };
  
  const getRoleBadgeColor = (role: UserRole) => {
    switch (role) {
      case "ADMIN":
        return "bg-red-100 text-red-800 border-red-200 hover:bg-red-200";
      case "DEVELOPER":
        return "bg-purple-100 text-purple-800 border-purple-200 hover:bg-purple-200";
      case "TESTER":
        return "bg-blue-100 text-blue-800 border-blue-200 hover:bg-blue-200";
      case "USER":
      default:
        return "bg-gray-100 text-gray-800 border-gray-200 hover:bg-gray-200";
    }
  };

  return (
    <Badge 
      variant="outline" 
      className={`flex items-center ${getRoleBadgeColor(role)}`}
    >
      {getRoleIcon(role)}
      {role}
      {role !== "USER" && onRemove && (
        <span 
          className="h-3 w-3 ml-1 cursor-pointer flex items-center justify-center"
          onClick={() => onRemove(role)}
        >
          ×
        </span>
      )}
    </Badge>
  );
}
